// Roles and permissions (A12U11, D183, D191): every role reads the five fixed roles (role.read).
import { ids } from '@orca/api-client/testIds'
import { createFileRoute } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { membersQuery } from '../../../../features/members/queries'
import { OrgSection } from '../../../../features/organization/OrgSection'
import { RolesPage } from '../../../../features/organization/RolesPage'
import { accessQuery } from '../../../../shared/access/access'
import { Part } from '../../../../shared/shell/StatePart'

export const Route = createFileRoute('/o/$orgSlug/organization/roles')({
  staticData: { screenId: 'AccessRolesScreen', access: 'role.read', ownHeader: true },
  loader: async ({ context: { queryClient, membership } }) => {
    await Promise.all([
      queryClient.ensureQueryData(accessQuery(membership.orgId)),
      queryClient.ensureQueryData(membersQuery(membership.orgId)),
    ])
    return { orgId: membership.orgId }
  },
  component: AccessRolesScreen,
})

function AccessRolesScreen() {
  const { t } = useTranslation()
  const { orgSlug } = Route.useParams()
  const { orgId } = Route.useLoaderData()
  return (
    <OrgSection
      orgId={orgId}
      section="roles"
      root={ids.accessRoles.root}
      title={t('organization.section.roles')}
      subtitle={t('organization.roles.subtitle')}
    >
      <Part>
        <RolesPage orgId={orgId} orgSlug={orgSlug} />
      </Part>
    </OrgSection>
  )
}
